import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

import Login from "../features/Authentication/screens/Login";
import SignUp from "../features/Authentication/screens/SignUp";

const Stack = createStackNavigator();

export default function AuthStack() {
  return (
    <Stack.Navigator headerMode="none">
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="Signup" component={SignUp} />
    </Stack.Navigator>
  );
}
